import React from 'react';

export const DropIcon = (props) => {
  return (
    <svg width='36px' height='32px' viewBox='0 0 36 32' {...props}>
      <g id='Symbols' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <path
          d='M33.8239588,9.18932381 L33.6133762,9.83555628 C33.4028699,10.4807489 33.1920496,11.1224255 32.9760272,11.7570181 L32.7580896,12.3891172 C30.6310973,18.474028 27.8657365,23.7858443 20.0465967,25.101634 C17.7436779,25.4942874 15.4969182,27.2106001 13.5631708,28.7447788 C9.76407397,31.7604427 6.53076377,32.0492936 1.92300477,29.5628217 C1.31440274,29.2356498 0.672806572,28.9700084 0.00100413063,28.7505655 L7.10542736e-15,0.000431729229 L35.452154,4.89039508e-14 C35.3323396,3.02172388 34.8318772,6.0809421 33.8239588,9.18932381 Z'
          id='Combined-Shape'
          fill='#66CC22'
          fillRule='nonzero'
        ></path>
      </g>
    </svg>
  );
};
